import { render, staticRenderFns } from "./AccountNotificationGeneral.vue?vue&type=template&id=7b7e8f65&scoped=true"
import script from "./AccountNotificationGeneral.vue?vue&type=script&lang=js"
export * from "./AccountNotificationGeneral.vue?vue&type=script&lang=js"
import style0 from "./AccountNotificationGeneral.vue?vue&type=style&index=0&id=7b7e8f65&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7e8f65",
  null
  
)

export default component.exports